// Sarv theme sidebar glyphs. SVGR (built into CRA) lets us import an SVG's
// ReactComponent and style it with CSS (color follows currentColor; the
// two-tone accent detail follows --icon-accent). Each nav concept below maps
// to the closest icon in the shared theme set.
import { ReactComponent as Dashboard } from '../theme/icons/sidebar/dashboard.svg';
import { ReactComponent as Service } from '../theme/icons/sidebar/service.svg';
import { ReactComponent as Zone } from '../theme/icons/sidebar/zone.svg';
import { ReactComponent as Manage } from '../theme/icons/sidebar/manage.svg';
import { ReactComponent as Notification } from '../theme/icons/sidebar/notification.svg';
import { ReactComponent as Reports } from '../theme/icons/sidebar/reports.svg';
import { ReactComponent as Forms } from '../theme/icons/sidebar/forms.svg';
import { ReactComponent as Live } from '../theme/icons/sidebar/live.svg';
import { ReactComponent as Models } from '../theme/icons/sidebar/models.svg';
import { ReactComponent as Tools } from '../theme/icons/sidebar/tools.svg';
import { ReactComponent as Resources } from '../theme/icons/sidebar/resources.svg';
import { ReactComponent as Throttle } from '../theme/icons/sidebar/throttle.svg';
import { ReactComponent as Settings } from '../theme/icons/sidebar/settings.svg';
import { ReactComponent as Web } from '../theme/icons/sidebar/web.svg';
import { ReactComponent as Users } from '../theme/icons/sidebar/users.svg';
import { ReactComponent as Channels } from '../theme/icons/sidebar/channels.svg';

const ICONS = {
  dashboard: Dashboard,
  servers: Service,
  clusters: Manage,
  cluster: Zone,
  alerts: Notification,
  'alert-search': Reports,
  playbooks: Forms,
  metrics: Reports,
  events: Live,
  gpu: Models,
  compute: Tools,
  instances: Resources,
  workloads: Tools,
  vpn: Throttle,
  configuration: Settings,
  network: Web,
  storage: Resources,
  access: Users,
  orgs: Manage,
  users: Users,
  groups: Channels,
  settings: Settings,
};

export default function NavIcon({ name, className = 'sidebar-icon' }) {
  const Glyph = ICONS[name];
  if (!Glyph) return <span className={className} aria-hidden="true" />;
  return <Glyph className={className} aria-hidden="true" focusable="false" />;
}
